module.exports = __webpack_public_path__ + "static/media/listMySpaceGreen.7d486a92.svg";